import axios from "axios";
import { jwtDecode } from 'jwt-decode';

export const getAccessToken = () => localStorage.getItem('accessToken');
export const getRefreshToken = () => localStorage.getItem('refreshToken');

export const isTokenExpired = (token: string) => {
  const decoded = jwtDecode(token);
  console.log('decoded', decoded);
  const expirationTime = decoded.exp ? decoded.exp : null;
  console.log('expirationTime', expirationTime, Date.now());
  return expirationTime ? Date.now() > expirationTime : true;
};

export const requestAccessToken = async (refreshToken: string) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/auth/token/refresh`,
      { refreshToken },
      { headers: {'Content-Type': 'application/json' } },
    );

    const { accessToken, refreshToken: newRefreshToken } = response.data;
    localStorage.setItem('accessToken', accessToken);
    if (newRefreshToken) {
      localStorage.setItem('refreshToken', newRefreshToken);
    }

    return accessToken;
  } catch (error) {
    console.error('Refresh token error:', error);
    throw error;
  }
};